import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCodepen,
  faFreeCodeCamp,
  faGithub,
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faPinterest,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faRss,
  faAngleUp,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faFolderOpen,
  faTags,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCodepen,
  faFreeCodeCamp,
  faGithub,
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faPinterest,
  faYoutube,
  faRss,
  faAngleUp,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faFolderOpen,
  faTags,
  faSearch
);
